import React, {useEffect} from 'react'

function SuspectCard(props) {
    useEffect(() => {
        flipAtStart()
        setTimeout(() => flipBack(), 1250)
    },[])
    
    function flipAtStart() {
        const cards = Array.from(document.querySelectorAll(".mugshotCard"))
        cards.forEach((card, index) => {
                if (index < 4 && index % 2 === 0) { 
                    card.classList.add("startingFlip") 
                } else if (index >= 4 && index % 2 !== 0) {
                    card.classList.add("startingFlip")
                }
        })
    }
    
    function flipBack() {
        const flippedCards = Array.from(document.querySelectorAll(".startingFlip"))
        flippedCards.forEach(card => card.classList.remove("startingFlip"))
    }
    
    return (
        <div className="flipCardWrapper mugshotCardWrapper">
            <div className="flipCard mugshotCard">
                <div className="flipCardFront mugshotCardFront">
                    <img className="flipCardImage" src={props.imageSource} alt={props.name + " mugshot"} />
                </div>
                <div className="flipCardBack mugshotCardBack">
                    <h2>{props.name}</h2> 
                    <p className="description">{props.description}</p>
                </div>
            </div>
        </div>
    )
}

export default SuspectCard